export const INSTANT_SEARCH_INDEX_NAME_BASE = 'petitions_';
export const INSTANT_SEARCH_PRESET_BASE = 'petitions_initial_';

export const INSTANT_SEARCH_SORT_BY_MOST_SIGNATURES = '/sort/total_signature_count:desc';
export const INSTANT_SEARCH_SORT_BY_LEAST_SIGNATURES = '/sort/total_signature_count:asc';
export const INSTANT_SEARCH_SORT_BY_NEWEST = '/sort/created_at:desc';

export const INSTANT_SEARCH_TOPIC_FILTER = 'tags';
export const INSTANT_SEARCH_VICTORY_FILTER = 'status';
export const INSTANT_SEARCH_LOCATION_CITY_FILTER = 'location.city_state';
export const INSTANT_SEARCH_LOCATION_COUNTRY_CODE_FILTER = 'location.country_code';
export const INSTANT_SEARCH_LOCATION_FILTER_MAX_ITEMS = 4;
export const INSTANT_SEARCH_TRENDING_FILTER = 'weekly_signature_count';
export const INSTANT_SEARCH_TRENDING_FILTER_VALUE = 10;
export const TYPESENSE_LOCATION_FILTER = 'city';
export const TYPESENSE_LOCATION_COLLECTION = 'locations';

export const INSTANT_SEARCH_CACHE_SECONDS = 2 * 60;

export const INSTANT_SEARCH_FACET_BY = `${INSTANT_SEARCH_TOPIC_FILTER},${INSTANT_SEARCH_VICTORY_FILTER},${INSTANT_SEARCH_LOCATION_CITY_FILTER},${INSTANT_SEARCH_LOCATION_COUNTRY_CODE_FILTER}`;
